import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import {catchError, delay, retry, tap} from 'rxjs/operators';
import {IApiBaseActions} from '../shared/interfaces/api-base-actions.interface';
import {ApiBaseResponse} from '../shared/interfaces/api-base-response.interface';
import {ApiError} from './api-error';

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService implements IApiBaseActions {
  constructor(private httpClient: HttpClient) {
  }

  Get(url: string): Observable<any> {
    return this.httpClient
      .get<ApiBaseResponse>(url)
      .pipe(
        tap((x) => this.HandleResponse(x)),
        catchError((error: ApiError) => {
          if (error.status === 0) {
            return throwError(error);
          } else {
            return of(error);
          }
        }),
        retry({delay:10000})
      );
  }



  GetAll(url: string) {
    return this.httpClient
      .get<ApiBaseResponse>(url)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  GetCoords(url: string) {
    return this.httpClient
      .get<any>(url)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Post(url: string, data: any) {
    return this.httpClient
      .post<ApiBaseResponse>(url, data)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Delete(url: string) {
    return this.httpClient
      .delete<ApiBaseResponse>(url)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Put(url: string, data: any) {
    return this.httpClient
      .put<ApiBaseResponse>(url, data)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  Patch(url: string, data: any) {
    return this.httpClient
      .patch<ApiBaseResponse>(url, data)
      .pipe(tap((x) => this.HandleResponse(x)));
  }

  HandleResponse(response: any) {
    if (response.Status === 500) {
      alert('there is an error while getting the data. please try again later');
    }
  }
}
